import { DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostListener,
	Inject,
	Input,
	ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AppController } from 'presentation/app.controller';
import { AppService } from 'presentation/app.service';
import { IUser } from 'user/user';

import { AppToolbarController } from './app-toolbar.controller';

@Component({
	selector: 'spr-app-toolbar',
	templateUrl: './app-toolbar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [AppToolbarController],
	host: {
		class:
			'top-0 left-0 right-0 flex flex-row p-3 fixed pl-0 items-center bg-white font-semibold p-shadow z-40',
	},
})
export class AppToolbarComponent {
	public title$: Observable<string>;
	public logoUrl$: Observable<string>;
	public hasUpdate$: Observable<boolean>;
	public sessionUser$: Observable<IUser>;
	public settingsUrl$: Observable<string[]>;
	public showCoachingBooth$: Observable<boolean>;

	@Input() public isFocusModeVisible: boolean;

	@ViewChild('toolbarMenu', { static: false })
	private _toolbarMenu: ElementRef<HTMLDivElement>;

	constructor(
		public appService: AppService,
		public appController: AppController,
		public controller: AppToolbarController,
		private _translateService: TranslateService,
		@Inject(DOCUMENT) private _document: Document
	) {
		this.showCoachingBooth$ = controller.showCoachingBooth$;
		this.settingsUrl$ = controller.settingsUrl$;
		this.sessionUser$ = controller.sessionUser$;
		this.hasUpdate$ = controller.hasUpdate$;
		this.logoUrl$ = controller.logoUrl$;
		this.title$ = controller.title$;
	}

	public onFocusModeChange(focusModeEnabled: boolean) {
		this.controller.updateFocusMode(focusModeEnabled);
	}

	public onDisconnectClick() {
		this.controller.closeSession();
	}

	public onUpdateClick() {
		this._document.location.reload();
	}

	public onHelpClick() {
		(window as any).Intercom('show');

		this.controller.markUserHelpConversationAsShown();
	}

	@HostListener('window:keydown')
	private _onKeyDown() {
		this.controller.updateLastInteraction();
	}

	@HostListener('window:mouseover')
	private _onMouseOver() {
		this.controller.updateLastInteraction();
	}
}
